import React, { useState } from 'react';
import { useWhatsappGroups } from '../../../features/admin/manageWhatsappGroups/application/useWhatsappGroups';
import { Button } from '../../../components/atoms/Button/Button';
import { Spinner } from '../../../components/atoms/Spinner/Spinner';
import styles from './ManageLinksWhatsapp.module.css';
import { ManageWhatsappGroupForm } from '../../../components/organism/ManageWhatsappGroupForm/ManageWhatsappGroupForm';
import { WhatsappGroupInterface } from '../../../features/admin/manageWhatsappGroups/domain';
import { Pagination } from '../../../components/molecules/Pagination/Pagination'
import {MdAddCircleOutline} from 'react-icons/md';

export const ManageLinksWhatsapp: React.FC = () => {
  const { manageWhatsappGroupsState, addWhatsappGroup, setWhatsappGroupForm, updateWhatsappGroup, handleNextPage, handlePrevPage } = useWhatsappGroups();
  const [isFormVisible, setIsFormVisible] = useState(false);
  const [action, setAction] = useState<'add' | 'update'>('add');

  const handleAddGroup = async (e: React.FormEvent) => {
    e.preventDefault();
    if (manageWhatsappGroupsState.whatsappGroupForm.name.trim() === '' || manageWhatsappGroupsState.whatsappGroupForm.link.trim() === '') {
      alert('Por favor, completa el nombre y el enlace del grupo.');
      return;
    }
    if (action === 'update') {
      await updateWhatsappGroup();
    } else {
      await addWhatsappGroup();
    }
    setIsFormVisible(false); // Cierra el modal después de agregar
  };

  const handleAddGroupForm = () => {
    setWhatsappGroupForm({ id: '', name: '', link: '', status: true });
    setAction('add');
    setIsFormVisible(true);
  };

  const handleUpdateGroup = (whatsappGroup: WhatsappGroupInterface) => {
    setWhatsappGroupForm(whatsappGroup);
    setAction('update');
    setIsFormVisible(true);
  }

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>Gestión de Grupos de WhatsApp</h1>

      <div className={styles.header}>
        <h2 className={styles.subtitle}>Grupos Existentes</h2>
        <Button color='accent' onClick={handleAddGroupForm} type="button">
          <MdAddCircleOutline className="inline mr-2" size={20} />
          Agregar Nuevo Grupo
        </Button>
      </div>

      {isFormVisible && (
        <ManageWhatsappGroupForm
          manageWhatsappGroupsState={manageWhatsappGroupsState}
          setWhatsappGroupForm={setWhatsappGroupForm}
          setIsFormVisible={setIsFormVisible}
          handleAddGroup={handleAddGroup}
          action={action}
        />
      )}

      {manageWhatsappGroupsState.loading && <Spinner />}
      {manageWhatsappGroupsState.error && <p className={styles.error}>{manageWhatsappGroupsState.error}</p>}

      {!manageWhatsappGroupsState.loading && !manageWhatsappGroupsState.error && (
        <>
          <div className={styles.tableContainer}>
            <table className={styles.table}>
              <thead>
                <tr>
                  <th>Nombre</th>
                  <th>Enlace</th>
                  <th>Estado</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {manageWhatsappGroupsState.whatsappGroups.length > 0 ? (
                  manageWhatsappGroupsState.whatsappGroups.map((group) => (
                    <tr key={group.id}>
                      <td>{group.name}</td>
                      <td><a href={group.link} target="_blank" rel="noopener noreferrer">{group.link}</a></td>
                      <td>
                        <span className={group.status ? styles.enabled : styles.disabled}>
                          {group.status ? 'Habilitado' : 'Deshabilitado'}
                        </span>
                      </td>
                      <td className={styles.actions}>
                        <Button color='terciary' onClick={() => handleUpdateGroup(group)} type="button" >
                          Actualizar
                        </Button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={4}>No hay grupos registrados.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <Pagination handlePrevPage={handlePrevPage} handleNextPage={handleNextPage} state={manageWhatsappGroupsState} />
        </>
      )}
    </div>
  );
};